import { withStyles, WithStyles } from "@material-ui/core/styles";
import React from "react";
import { Button } from "@material-ui/core";
import { styles } from "./BlueButton.styles";

interface IBlueButtonProps extends WithStyles<typeof styles> {
    onClick: any;
    style?: any,
    children?: React.ReactNode,
    fullWidth?: boolean,
    disabled?: boolean,
}

const BlueButtonPure: React.FunctionComponent<IBlueButtonProps> = ({style, fullWidth, onClick, children, disabled, classes}: IBlueButtonProps) => {
    return (
        <Button disabled={disabled} fullWidth={fullWidth} style={style} onClick={onClick} disableElevation disableRipple color="primary" variant="contained"
                className={classes.button}>
            {children}
        </Button>
    );
};

export const BlueButton = withStyles(styles)(BlueButtonPure);
